import { versiondev, version } from '../../../../package.json';

export const environment = {
  production: false,
  apiUrlV1: 'https://api.smartsheep.at/api/dev',
  versiondev,
  version,
  keycloak: 'smartsheep-dev',
  stripe: {
    prices: {
      pro_monthly: 'price_1TbxcZEAG5HpoHjjiUc2dwUA',
      pro_yearly: 'price_1Tbxc3EAG5HpoHjjJFfiOqGM',
      premium_monthly: 'price_1TbxdNEAG5HpoHjjznSnnNIA',
      premium_yearly: 'price_1Tbxd8EAG5HpoHjjTLJ6w7BZ',
    },
  },
};
